import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { FaFilter, FaTimes } from "react-icons/fa";

const FunnelFilter = ({ options, selectedOption, onFilterChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const toggleOpen = (event) => {
    event.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleFilterChange = (option) => {
    onFilterChange(option);
    setIsOpen(false);
  };

  const clearFilter = (event) => {
    event.stopPropagation();
    onFilterChange("All"); // Clear filter by resetting to "All"
  };

  useEffect(() => {
    const element = document.querySelector(".funnel-dropdown");
    const rect = ref.current.getBoundingClientRect();

    if (element && rect) {
      element.style.top = `${rect.bottom + window.scrollY}px`;
      element.style.left = `${rect.left}px`;
    }
  }, [isOpen]);

  const dropdown = (
    <div className="funnel-dropdown">
      {options.map((option) => (
        /* fixed this accessibility issue,make the clickable div element keyboard-accessible by:
          Adding a tabIndex prop to make it focusable
          Adding an onKeyDown handler for keyboard interaction
          Using the semantically appropriate ARIA role
          Adding appropriate ARIA labels */
        <div
          key={option}
          onClick={(e) => {
            e.stopPropagation();
            handleFilterChange(option);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              e.stopPropagation();
              handleFilterChange(option);
            }
          }}
          className={`${option === selectedOption ? "selected" : ""}`}
          role="menuitem"
          tabIndex={0}
          aria-selected={option === selectedOption}
        >
          {option}
        </div>
      ))}
    </div>
  );

  return (
    <div
      ref={ref}
      className="filter-container"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        onClick={toggleOpen}
        className={`filter-button ${selectedOption !== "All" ? "active" : ""}`}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <FaFilter
          size={18}
          className={`filter-icon ${selectedOption !== "All" ? "active" : ""}`}
        />
        {selectedOption !== "All" && (
          <FaTimes
            size={14}
            className="clear-icon"
            onClick={clearFilter}
            title="Clear Filter"
          />
        )}
      </button>
      {isOpen && createPortal(dropdown, document.body)}
    </div>
  );
};

export default FunnelFilter;
